
export default{
    newCreatedTSL: {},
}